/**
 * @packageDocumentation
 * @module api.functional.auth.instant_login
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { AuthResponseDto } from "../../../structures/AuthResponseDto";

/**
 * @controller AuthController.loginWithInstantLink
 * @path POST /auth/instant-login
 * @accessor api.functional.auth.instant_login.loginWithInstantLink
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function loginWithInstantLink(
  connection: IConnection,
  token: string,
): Promise<loginWithInstantLink.Output> {
  return PlainFetcher.fetch(connection, {
    ...loginWithInstantLink.METADATA,
    template: loginWithInstantLink.METADATA.path,
    path: loginWithInstantLink.path(token),
  });
}
export namespace loginWithInstantLink {
  export type Output = AuthResponseDto;

  export const METADATA = {
    method: "POST",
    path: "/auth/instant-login",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 201,
  } as const;

  export const path = (token: string) => {
    const variables: URLSearchParams = new URLSearchParams();
    for (const [key, value] of Object.entries({
      token: token,
    } as any))
      if (undefined === value) continue;
      else if (Array.isArray(value))
        value.forEach((elem: any) => variables.append(key, String(elem)));
      else variables.set(key, String(value));
    const location: string = "/auth/instant-login";
    return 0 === variables.size
      ? location
      : `${location}?${variables.toString()}`;
  };
}
